import { render } from "./FrequencyBadge.vue?vue&type=template&id=27b64f94"
import script from "./FrequencyBadge.vue?vue&type=script&lang=js"
export * from "./FrequencyBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__